import React from 'react';
import { useSelector } from 'react-redux';
import { Container, Row, SideCol } from '@yme/atoms/grid';
import { buildKey } from '@yme/common/index';
import { IndentWrapper } from '@yme/components/Separator';
import { getRTL } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { LEFT_ALIGN } from './constants';
import { DescriptionStyled, DividerStyled, ImageStyled } from './styled';
export function ImageWithDescription(props) {
    const { description, image, imageAlign, isRemoveBottomIndent } = props;
    const isRightToLeft = useSelector(getRTL);
    const isLeftAlign = imageAlign === LEFT_ALIGN;
    if (description && image) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(Container, { dataTestId: buildKey('image-with-description', isLeftAlign ? 'image-left' : 'image-right') },
                React.createElement(Row, { flexDirection: isLeftAlign ? 'row' : 'row-reverse' },
                    React.createElement(SideCol, { lg: 9, md: 5, sm: 4, isLeftAlign: isLeftAlign, smFixed: false, mdFixed: true, lgFixed: true },
                        React.createElement(ImageStyled, { ...image })),
                    React.createElement(DescriptionStyled, { lg: 3, md: 3, sm: 4, isRightToLeft: isRightToLeft },
                        React.createElement(DividerStyled, null),
                        React.createElement(RegularTextLevel4, { color: colorCoreBlack300 }, description))))));
    }
    return null;
}
ImageWithDescription.displayName = 'ImageWithDescription_AEMComponent';
